import GoogleTagManager from 'react-gtm-module';

const GTM_ID = 'GTM-W2KFPM7';
const ENVIRONMENT = 'prod';

class GtmService {
    initialize(dataLayer) {
        if (GTM_ID && ENVIRONMENT === 'prod') {
            GoogleTagManager.initialize({
                gtmId: GTM_ID,
                dataLayer
            });
        }
    }
}

export default new GtmService();
